import { Component, Input } from "@angular/core";
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActionService } from "../../../services/action.service";
import { NgClass } from "@angular/common";
import { DisableAutocompleteDirective } from "../../../../../shared/disable-autocomplete/disable-autocomplete.directive";
import { MentionModule } from "angular-mentions";
import { ErrorDisplayComponent } from "../../../../../shared/error-display/error-display.component";

@Component({
    selector: "action-text-input",
    styleUrls: ["./action-text-input.component.scss"],
    templateUrl: "./action-text-input.component.html",
    standalone: true,
    imports: [NgClass, FormsModule, DisableAutocompleteDirective, MentionModule, ReactiveFormsModule, ErrorDisplayComponent]
})
export class ActionTextInputComponent {

    @Input() i: number;
    @Input() fieldLabel: string;
    @Input() name: string;
    @Input() actionMention: any[] = [];
    @Input() actionMentionConfig: any = { triggerChar: '@', items: [], mentions: [] };
    @Input() control: UntypedFormControl;

    constructor(private actionService: ActionService) { }
    getTooltipData(errors: Object): string | void {
        return this.actionService.getTooltipData(errors);
    }
}
